import { Controller, Input, useFormContext } from '@qred/components-library';
import { Select } from '@qred/components-library/next';
import React from 'react';
import { LoanPurposes } from '~/enums';
import { useLoanPurposeTranslationMapper } from '~/hooks/useLoanPurposeTranslationMapper';
import useTranslate from '~/hooks/useTranslate';
import { StartApplicationForm } from '../StartApplication.schema';

export const LoanPurposeSelect = () => {
  const t = useTranslate();
  const {
    control,
    resetField,
    watch,
    trigger,
  } = useFormContext<StartApplicationForm>();

  const loanPurpose = watch('loanPurpose');

  const loanPurposeTranslationMapper = useLoanPurposeTranslationMapper();

  const options = [
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Equipment],
      value: LoanPurposes.Equipment,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.RepayOtherLoan],
      value: LoanPurposes.RepayOtherLoan,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Hiring],
      value: LoanPurposes.Hiring,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Marketing],
      value: LoanPurposes.Marketing,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Inventory],
      value: LoanPurposes.Inventory,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Expansion],
      value: LoanPurposes.Expansion,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Working],
      value: LoanPurposes.Working,
    },
    {
      label: loanPurposeTranslationMapper[LoanPurposes.Other],
      value: LoanPurposes.Other,
    },
  ];

  return (
    <>
      <Controller
        control={control}
        name="loanPurpose.purposeOfLoan"
        render={({ field, fieldState }) => {
          return (
            <Select
              label={t('LoanPurpose') as string}
              data={options}
              value={field.value}
              onChange={(value) => {
                if (!value) {
                  field.onChange(undefined);
                  return;
                }

                resetField('loanPurpose', {
                  defaultValue: {
                    purposeOfLoan: value as LoanPurposes,
                    reason: '',
                  },
                });
              }}
              onBlur={() => trigger('loanPurpose.purposeOfLoan')}
              error={fieldState.error?.message && t(fieldState.error.message)}
              allowDeselect={false}
            />
          );
        }}
      />

      {loanPurpose.purposeOfLoan === LoanPurposes.Other && (
        <Controller
          control={control}
          name="loanPurpose.reason"
          render={({ field, fieldState }) => {
            return (
              <Input
                label={t('Onboarding.LoanPurposeSpecifyPurpose')}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message && t(fieldState.error.message)}
              />
            );
          }}
        />
      )}
    </>
  );
};
